export default __webpack_public_path__ + "static/media/logo-white.4624e6b2.svg";